import reduxCrud from 'redux-crud';

const transactionsReducers = reduxCrud.Map.reducersFor('transactions', {
  key: 'id',
});

export default transactionsReducers;
